import apiClient from './client';

function getSessionId(): string {
    const key = 'ww_session_id';
    let id = sessionStorage.getItem(key);
    if (!id) {
        id = crypto.randomUUID();
        sessionStorage.setItem(key, id);
    }
    return id;
}

// Parsed once per page load and reused for every event.
const deviceInfo = (() => {
    const ua = navigator.userAgent;

    const os = (() => {
        if (/Windows/i.test(ua))             return 'Windows';
        if (/iPhone|iPad|iPod/i.test(ua))    return 'iOS';
        if (/Android/i.test(ua))             return 'Android';
        if (/Mac OS X/i.test(ua))            return 'macOS';
        if (/Linux/i.test(ua))               return 'Linux';
        return 'Other';
    })();

    const browser = (() => {
        if (/Edg\//i.test(ua))               return 'Edge';
        if (/OPR\//i.test(ua))               return 'Opera';
        if (/Firefox\//i.test(ua))           return 'Firefox';
        if (/Chrome\//i.test(ua))            return 'Chrome';
        if (/Safari\//i.test(ua))            return 'Safari';
        return 'Other';
    })();

    const platform = (() => {
        if (/Mobi|Android/i.test(ua))        return 'mobile';
        if (/Tablet|iPad/i.test(ua))         return 'tablet';
        return 'desktop';
    })();

    return {
        os,
        browser,
        platform,
        screen: `${window.screen.width}x${window.screen.height}`,
        language: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
    };
})();

// Fire-and-forget: never throws, never blocks the caller.
// Pass withDevice: true to include OS/browser/platform/screen/language/timezone.
export function trackEvent(
    eventName: string,
    properties?: Record<string, unknown>,
    options?: { withDevice?: boolean },
): void {
    const props = options?.withDevice
        ? { ...deviceInfo, ...(properties ?? {}) }
        : (properties ?? {});

    apiClient
        .post('/api/v1/events', {
            event_name: eventName,
            properties: props,
            session_id: getSessionId(),
        })
        .catch(() => {
            // intentionally silent — analytics must never break the UI
        });
}
